module.exports = {
        srcSet: __webpack_public_path__ + "0a781010ee3ee66f-600.webp"+" 600w"+","+__webpack_public_path__ + "6c3c1f973e94a152-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "0a781010ee3ee66f-600.webp",width: 600,height: 900},{path: __webpack_public_path__ + "6c3c1f973e94a152-1000.webp",width: 1000,height: 1500}],
        src: __webpack_public_path__ + "6c3c1f973e94a152-1000.webp",
        toString: function(){return __webpack_public_path__ + "6c3c1f973e94a152-1000.webp"},
        
        width: 1000,
        height: 1500
      }